// extracted by css-extract-rspack-plugin
export default {"areaControl":"PermissionsList_areaControl__YzvUr","areaHeader":"PermissionsList_areaHeader__NdQUN","domainList":"PermissionsList_domainList__Llqcd"};